import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2'
import 'bootstrap'
import Multiselect from 'vue-multiselect'
import VueIframe from 'vue-iframes'
import moment from 'moment'
import 'moment-timezone'
var CodeMirrorLiteJs = require('vue2-codemirror-lite-js')

Vue.use(CodeMirrorLiteJs)
/* import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyCdp7emiEKga0LQ1nnZRHFwsEh6T-ILTus',
		libraries: 'places',
	},
}) */

import GmapVue from 'gmap-vue'
Vue.use(GmapVue, {
	load: {
		// [REQUIRED] This is the unique required value by Google Maps API
		key: 'AIzaSyA5vUBm-rTYKcpldx-3jhWWh8wtewMVST8',
		// [OPTIONAL] This is required if you use the Autocomplete plugin
		// OR: libraries: 'places,drawing'
		// OR: libraries: 'places,drawing,visualization'
		// (as you require)
		libraries: 'places,drawing',
		v: '3.26',

		// This option was added on v3.0.0 but will be removed in the next major release.
		// If you already have an script tag that loads Google Maps API and you want to use it set you callback
		// here and our callback `GoogleMapsCallback` will execute your custom callback at the end; it must attached
		// to the `window` object, is the only requirement.
		//customCallback: 'MyCustomCallback',
	},

	// [OPTIONAL] If you intend to programmatically custom event listener code
	// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
	// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
	// you might need to turn this on.
	autoBindAllEvents: false,

	// [OPTIONAL] If you want to manually install components, e.g.
	// import {GmapMarker} from 'gmap-vue/src/components/marker'
	// Vue.component('GmapMarker', GmapMarker)
	// then set installComponents to 'false'.
	// If you want to automatically install all the components this property must be set to 'true':
	installComponents: true,

	// Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
	dynamicLoad: false,
})

// enables us to store and get objests in browser storage
Storage.prototype.setObject = function (key, value) {
	this.setItem(key, JSON.stringify(value))
}
Storage.prototype.getObject = function (key) {
	return JSON.parse(this.getItem(key))
}

// Use VueIframe
Vue.use(VueIframe)

// register globally
Vue.component('multiselect', Multiselect)

Vue.directive('click-outside', {
	bind() {
		this.event = event => this.vm.$emit(this.expression, event)
		this.el.addEventListener('click', this.stopProp)
		document.body.addEventListener('click', this.event)
	},
	unbind() {
		this.el.removeEventListener('click', this.stopProp)
		document.body.removeEventListener('click', this.event)
	},

	stopProp(event) {
		event.stopPropagation()
	},
})

Vue.use(VueSweetalert2, {
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
})

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faAddressBook,
	faArrowCircleDown,
	faArrowCircleUp,
	faBars,
	faBox,
	faCheckCircle,
	faHdd,
	faTag,
	faCity,
	faClock,
	faCogs,
	faEdit,
	faEnvelope,
	faFileCsv,
	faHistory,
	faHouseUser,
	faInfoCircle,
	faLock,
	faMailBulk,
	faPaperclip,
	faPlus,
	faPlusCircle,
	faTimes,
	faBuilding,
	faUser,
	faUserEdit,
	faUserPlus,
	faUsers,
	faUserTie,
	faTrash,
	faEye,
	faPenSquare,
	faShippingFast,
	faFilePdf,
	faFrownOpen,
	faCog,
	faArrowAltCircleUp,
	faLink,
	faDoorOpen,
	faPen,
	faAt,
	faSave,
	faCloud,
	faFilter,
	faSuitcase,
	faColumns,
	faNewspaper,
	faEyeSlash,
	faChevronLeft,
	faChevronRight,
	faChevronDown,
	faChevronUp,
	faUmbrella,
	faImages,
	faSpinner,
	faEraser,
	faSlidersH,
	faSortAmountUp,
	faSortAmountDown,
	faListOl,
	faThList,
	faFingerprint,
	faArrowCircleLeft,
	faGlobeAmericas,
	faGlobe,
	faInfo,
	faCloudDownloadAlt,
	faReceipt,
	faHandHoldingUsd,
	faSearch,
	faBug,
	faEnvelopeOpen,
	faMoneyCheckAlt,
	faCheckSquare,
	faDollarSign,
	faPaperPlane,
	faCopy,
	faCloudUploadAlt,
	faChargingStation,
	faBell,
	faArrowsAlt,
	faWrench,
	faCheck,
	faBan,
	faList,
	faPalette,
	faFileInvoiceDollar,
	faExternalLinkAlt,
	faExclamation,
	faExclamationCircle,
	faExclamationTriangle,
	faHammer,
	faAddressCard,
	faUserMinus,
	faUserTimes,
	faUserCheck,
	faTimesCircle,
	faSyncAlt,
	faUndo,
	faSortUp,
	faSortDown,
	faUserTag,
	faTrashAlt,
	faUserLock,
	faUsersCog,
	faBroom,
	faBolt,
	faRocket,
	faStream,
	faUpload,
	faCode,
	faMagic,
	faFile,
	faFileImport,
	faQuestionCircle,
	faSync,
	faBoxOpen,
	faSwatchbook,
	faHeart,
	faTint,
	faStopwatch,
	faBookmark,
	faArchive,
	faExchangeAlt,
	faFileDownload,
	faDownload,
	faPlay,
	faSignature,
	faChartLine,
	faMapMarkedAlt,
	faPuzzlePiece,
	faCodeBranch,
	faCalendarAlt,
	faArrowLeft,
	faFileAlt,
	faImage,
	faArrowRight,
	faPhone,
	faPlayCircle,
	faPause,
	faInbox,
	faRedo,
	faCircle,
	faFlask,
	faHardHat,
	faKey,
	faCube,
	faCubes,
	faRoute,
	faServer,
	faBrain,
	faUniversalAccess,
	faSitemap,
	faCalendarDay,
	faGavel,
	faFolder,
	faLayerGroup,
	faThLarge,
	faWindowMaximize,
	faWindowMinimize,
	faMitten,
	faLandmark,
	faBullhorn,
	faCreditCard,
	faCalendarCheck,
	faIdCard,
	faFileContract,
} from '@fortawesome/free-solid-svg-icons'
import {
	faPaperPlane as farPaperPlane,
	faSave as farSave,
	faEdit as farEdit,
	faObjectGroup,
	faHeart as farHeart,
	faBookmark as farBookmark,
	faChartBar,
} from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebook, faGithub, faGoogle, faHtml5, faWikipediaW, faUsps, faSearchengin } from '@fortawesome/free-brands-svg-icons'

library.add(
	faBars,
	faHouseUser,
	faPaperclip,
	faBox,
	faCogs,
	faUsers,
	faGithub,
	faGoogle,
	faFacebook,
	faInfoCircle,
	faBuilding,
	faUser,
	faClock,
	faLock,
	faUserEdit,
	faEdit,
	faUserPlus,
	faHistory,
	faArrowCircleDown,
	faArrowCircleUp,
	faCity,
	faFileCsv,
	faCheckCircle,
	faHdd,
	faTag,
	faPlus,
	faPlusCircle,
	faTimes,
	faMailBulk,
	faAddressBook,
	faUserTie,
	faEnvelope,
	faTrash,
	faEye,
	faPenSquare,
	faShippingFast,
	faFilePdf,
	faWikipediaW,
	faFrownOpen,
	faCog,
	faArrowAltCircleUp,
	faLink,
	faDoorOpen,
	faPen,
	faAt,
	faSave,
	faCloud,
	faFilter,
	faSuitcase,
	faColumns,
	faNewspaper,
	faEyeSlash,
	faChevronLeft,
	faChevronRight,
	faChevronDown,
	faChevronUp,
	faHtml5,
	faUmbrella,
	faImages,
	faSpinner,
	faEraser,
	faSlidersH,
	faSortAmountUp,
	faSortAmountDown,
	faListOl,
	faThList,
	faFingerprint,
	faArrowCircleLeft,
	faGlobe,
	faGlobeAmericas,
	faInfo,
	faCloudDownloadAlt,
	faReceipt,
	faHandHoldingUsd,
	faSearch,
	faBug,
	faEnvelopeOpen,
	faMoneyCheckAlt,
	faCheckSquare,
	faDollarSign,
	faPaperPlane,
	faCopy,
	faCloudUploadAlt,
	faChargingStation,
	faBell,
	faUsps,
	faArrowsAlt,
	faWrench,
	faCheck,
	faBan,
	faList,
	faPalette,
	faFileInvoiceDollar,
	faExternalLinkAlt,
	faExclamation,
	faExclamationCircle,
	faExclamationTriangle,
	faHammer,
	faAddressCard,
	faUserMinus,
	faUserTimes,
	faUserCheck,
	farPaperPlane,
	faTimesCircle,
	faSyncAlt,
	faUndo,
	faSortUp,
	faSortDown,
	faUserTag,
	farSave,
	faTrashAlt,
	farEdit,
	faUserLock,
	faUsersCog,
	faObjectGroup,
	faBroom,
	faBolt,
	faRocket,
	faStream,
	faUpload,
	faCode,
	faMagic,
	faFile,
	faFileImport,
	faQuestionCircle,
	faSearchengin,
	faSync,
	faBoxOpen,
	faSwatchbook,
	faHeart,
	faTint,
	faStopwatch,
	faHeart,
	farHeart,
	faBookmark,
	farBookmark,
	faChartBar,
	faArchive,
	faExchangeAlt,
	faFileDownload,
	faDownload,
	faPlay,
	faSignature,
	faChartLine,
	faMapMarkedAlt,
	faPuzzlePiece,
	faCodeBranch,
	faCalendarAlt,
	faArrowLeft,
	faFileAlt,
	faImage,
	faArrowRight,
	faPhone,
	faPlayCircle,
	faPause,
	faInbox,
	faPen,
	faRedo,
	faCircle,
	faFlask,
	faHardHat,
	faKey,
	faCube,
	faCubes,
	faRoute,
	faServer,
	faBrain,
	faUniversalAccess,
	faSitemap,
	faCalendarDay,
	faGavel,
	faFolder,
	faLayerGroup,
	faThLarge,
	faWindowMaximize,
	faWindowMinimize,
	faMitten,
	faLandmark,
	faBullhorn,
	faCreditCard,
	faCalendarCheck,
	faIdCard,
	faFileContract,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import JuniperPageHeader from '@/components/juniper/layout/JuniperPageHeader.vue'
Vue.component('JuniperPageHeader', JuniperPageHeader)

// Attach moment to the Vue prototype
Vue.prototype.moment = moment
Vue.prototype.momentTz = moment.tz // Add the timezone functionality

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')

//Local directive registration
